<template>
  <el-card @click="adminshow" class="box-card user">
    <div slot="header" class="clearfix">
      <!-- 标题 -->
      <span class="font-sz24">公告管理</span>
      <div class="head-text">
        <!-- 新建事件 -->
        <el-button type="primary" @click="showUserSubmit">新建</el-button>
        <el-button type="danger" class="mar-left4" @click="batchDeletion"
          >删除</el-button
        >
      </div>
    </div>

    <!-- 表格 -->
    <div class="announcement-table">
      <el-table
        :data="tableData"
        class="width100"
        :default-sort="{ prop: 'date', order: 'ascending' }"
        @selection-change="handleSelectionChange"
        v-loading="loading"
        height="72vh"
      >
        <el-table-column
          align="center"
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column
          align="center"
          type="index"
          width="50"
          label="序号"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="noti04"
          label="名称"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="noti07"
          label="阅读量"
          sortable
        ></el-table-column>
        <el-table-column
          align="center"
          prop="noti06"
          label="更新时间"
          sortable
        ></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              plain
              @click="editorDialogFormVisible(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              class="mar-left2"
              size="small"
              plain
              @click="removeannouncement(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageDate"
      :page-sizes="[100, 50, 10]"
      :page-size="10"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagess"
      align="center"
      class="mar-top20"
    ></el-pagination>

    <!-- 新建 -->
    <el-dialog
      :close-on-click-modal="false"
      title="新建公告"
      :visible.sync="addDialogFormVisible"
    >
      <el-form :model="addForm1" label-width="80px" ref="addForm1">
        <el-form-item label="名称" prop="noti04">
          <el-input v-model="addForm1.noti04" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="noti02">
          <el-input
            type="number"
            v-model.number="addForm1.noti02"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="标题颜色" prop="noti03">
          <div class="block">
            <el-color-picker v-model="addForm1.noti03"></el-color-picker>
          </div>
        </el-form-item>
        <el-form-item label="内容" prop="noti05">
          <ckediter4 ref="ck" v-model="addForm1.noti05"></ckediter4>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addUserSubmit()" v-if="btnShow"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 编辑用户 -->
    <el-dialog
      :close-on-click-modal="false"
      title="编辑公告信息"
      :visible.sync="editorDialogFormVisible1"
      width="50%"
      height="50%"
    >
      <el-form :model="addForm" label-width="80px" ref="addForm">
        <el-form-item label="名称" prop="noti04">
          <el-input
            :style="{ color: addForm.noti03 }"
            v-model="addForm.noti04"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="noti02">
          <el-input v-model="addForm.noti02" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="标题颜色" prop="noti03">
          <div class="block">
            <el-color-picker v-model="addForm.noti03"></el-color-picker>
          </div>
        </el-form-item>
        <el-form-item label="内容" prop="noti05">
          <ckediter4 ref="ck2" v-model="addForm.noti05"></ckediter4>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editor" v-if="btnShow"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </el-card>
</template>
<script>
import FileSaver from "file-saver";
import XLSX from "xlsx";
import ckediter4 from "@/components/ck.vue";
import {
  Addannouncement,
  getannouncement,
  CompilePublicity,
  Removeannouncement,
  FindNotice,
} from "@/setAxios.js";
export default {
  name: "announcement",
  props: ["showAdmin"],
  components: {
    ckediter4,
  },
  data() {
    return {
      pageDate: 1,
      pagess: 10,
      value2: false,
      loading: true,
      value1: "",
      color1: "#409EFF",
      color2: null,
      tableData: [],
      total: 0,
      pagesize: 10,
      pagenum: 1,
      btnShow: true,
      addDialogFormVisible: false,
      editorDialogFormVisible1: false,
      seeDialogFormVisible1: false,
      multipleSelection: [],
      editForm: {},
      addForm: {
        noti01: null,
        noti02: null,
        noti03: null,
        noti04: null,
        noti05: null,
        noti06: "",
        noti07: 0,
      },
      addForm1: {
        noti02: null,
        noti03: "#302424",
        noti04: null,
        noti05: null,
        noti06: "",
        noti07: 0,
      },
    };
  },
  //   模型初始化时调用方法请求接口
  created() {
    // 获取当前日期
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    this.addForm1.noti06 = year + "-" + month + "-" + day;
    this.getData();
  },
  methods: {
    // 导出表格所用
    exportExcel() {
      // 设置当前日期
      let time = new Date();
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      let name = year + "" + month + "" + day;
      // //(name)
      /* generate workbook object from table */
      //  .table要导出的是哪一个表格
      var wb = XLSX.utils.table_to_book(document.querySelector(".table"));
      /* get binary string as output */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        //  name+'.xlsx'表示导出的excel表格名字
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          name + ".xlsx"
        );
      } catch (e) {
        // if (typeof console !== "undefined") //(e, wbout);
      }
      return wbout;
    },
    addcount() {
      GetDeptList().then((res) => {
        this.deptList = res.data;
      });
    },
    // 批量删除
    batchDeletion() {
      if (this.multipleSelection.length > 0) {
        this.$confirm("此操作将永久删除所选择公告, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          var Selection = [];
          this.multipleSelection.forEach((item, index) => {
            Selection.push(item.noti01);
          });
          Removeannouncement({ ids: Selection.toString() }).then((res) => {
            if (res.Code > 0) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.pagenum = 1;
              this.getData();
            } else {
              this.$message({
                message: "删除失败",
                type: "warning",
              });
            }
          });
        });
      } else {
        this.$message({
          message: "没有选择",
          type: "warning",
        });
      }
    },
    // 编辑
    editUserSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            id: this.editForm.user01,
            name: this.editForm.user12,
          };
          CheckName2(params).then((res) => {
            if (res.state == 0) {
              EditAccount({ editvalue: JSON.stringify(this.editForm) }).then(
                (res) => {
                  if (res.state == 1) {
                    this.$message({
                      message: "修改成功",
                      type: "success",
                    });
                    //(111);
                    this.seeDialogFormVisible1 = false;
                    this.getData();
                  } else {
                    this.$message({
                      message: "修改失败",
                      type: "warning",
                    });
                  }
                  // this.seeDialogFormVisible1 = false;
                  this.getData();
                }
              );
            } else {
              this.$message({
                message: "用户名不可用",
                type: "warning",
              });
            }
          });
        }
      });
    },
    // 这里是查看
    seeDialogFormVisible() {
      this.seeDialogFormVisible1 = true;
    },
    // 打开新建
    showUserSubmit() {
      this.addDialogFormVisible = true;
    },
    // 这里是新建确定键
    addUserSubmit() {
      this.addForm1.noti05 = this.$refs.ck.ckeditor.getData();
      let params = JSON.stringify(this.addForm1);
      Addannouncement({ notice: params }).then((res) => {
        //(res);
        this.getData();
        this.addDialogFormVisible = false;
      });
    },
    // 这里是关联管理
    associatedDialogFormVisible(row) {
      this.associatedDialogFormVisible1 = true;
    },
    // 这里是取消关联
    associatedDialogFormVisible2(row) {},
    // 删除用户
    removeannouncement(row) {
      //(row.noti01);
      this.$confirm("是否刪除此公告管理?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = JSON.stringify(row.noti01);
          Removeannouncement({ ids }).then((res) => {
            //(res);
            this.getData();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 这里获取所有数据
    getData() {
      this.loading = true;
      let params = {
        pageIndex: this.pagenum,
        pageSize: this.pagesize,
      };
      getannouncement({ params })
        .then((res) => {
          //(res.Data.list);
          this.pagess = res.Data.total;
          this.tableData = res.Data.list;
          this.total = res.total;
          setTimeout(() => {
            this.loading = false;
          }, 600);
        })
        .catch((err) => {
          //(err);
        });
    },
    //显示编辑用户对话框
    editorDialogFormVisible(row) {
      //(row);
      let params = {
        id: row.noti01,
      };
      FindNotice({ params }).then((res) => {
        // //(res,1111111111111)
        this.addForm = res.Data;
        this.editorDialogFormVisible1 = true;
      });
    },
    //编辑确定按键
    editor() {
      this.addForm.noti05 = this.$refs.ck2.ckeditor.getData();
      let params = JSON.stringify(this.addForm);
      CompilePublicity({ notice: params }).then((res) => {
        //(res);
        this.editorDialogFormVisible1 = false;
        this.getData();
      });
    },
    stopDialogFormVisible(row) {
      ProhibitAccount({ id: row.user01, state: row.user09 == 0 ? 1 : 0 }).then(
        (res) => {
          this.getData();
        }
      );
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      //(val);
    },
    handleSizeChange(val) {
      //   //(`每页 ${val} 条`)
      this.pagesize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      //   //(`当前页: ${val}`)
      // //("当前页码"+this.pagesize)
      this.pagenum = val;
      this.getData();
    },
    setCurrent(row) {
      this.$refs.singleTable.setCurrentRow(row);
    },
    handleCurrentChange2(val) {
      this.currentRow = val;
    },
    replaceSub() {
      this.seeDialogFormVisible2 = true;
    },
    // 关闭菜单栏显示
    adminshow() {
      this.$emit("update:showAdmin", true);
    },
  },
  watch: {
    color1: function (a, b) {
      //(a, b);
      this.color1 = a;
      //(this.color1);
    },
  },
};
</script>
<style lang="less" scoped>
.user .search-input {
  width: 300px;
}
table.el-table__header {
  line-height: 60px;
}

.el-button {
  margin: 0;
}
//新增
.font-sz24 {
  font-size: 24px;
}
.head-text {
  float: right;
  margin-top: -4px;
}
.width100 {
  width: 100%;
}
.mar-left4 {
  margin-left: 4px;
}
.margin-bot2 {
  margin: 0 0 0 2px;
}
.mar-top20 {
  margin-top: 20px;
}
</style>
